var map = {
	"./polecenie.mp3": "7e92",
	"./z17s35-10.mp3": "567e",
	"./z17s35-11.mp3": "5ea4",
	"./z17s35-12.mp3": "d39c",
	"./z17s35-13.mp3": "b1ac",
	"./z17s35-7.mp3": "091c",
	"./z17s35-8.mp3": "5fa9",
	"./z17s35-9.mp3": "dc94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0318";